import { render, staticRenderFns } from "./location_super_categs.vue?vue&type=template&id=d65b5e30&scoped=true&"
import script from "./location_super_categs.vue?vue&type=script&lang=js&"
export * from "./location_super_categs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65b5e30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d65b5e30')) {
      api.createRecord('d65b5e30', component.options)
    } else {
      api.reload('d65b5e30', component.options)
    }
    module.hot.accept("./location_super_categs.vue?vue&type=template&id=d65b5e30&scoped=true&", function () {
      api.rerender('d65b5e30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_modal/tabs/location_super_categs.vue"
export default component.exports